import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { getPortfolioDetail } from '../lib/portfolio';

export const usePortfolioDetail = (kind, slug) => {
  const navigate = useNavigate();
  const detail = useMemo(() => getPortfolioDetail(kind, slug), [kind, slug]);
  const { item, basePath } = detail;
  useEffect(() => {
    if (!item) navigate(basePath, { replace: true });
  }, [item, basePath, navigate]);
  return detail;
};